var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-gray-300 flex flex-col h-16- sm:h-16 flex-grow"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }